import { render, staticRenderFns } from "./CityOperationalIndicators.vue?vue&type=template&id=08920589"
import script from "./CityOperationalIndicators.vue?vue&type=script&lang=js"
export * from "./CityOperationalIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports